import React, {useContext, useReducer, createContext} from 'react';
// import { collection, addDoc, getDoc, setDoc, doc } from "firebase/firestore";
import {db} from '../Firebase/firebase'

const whatsappContext = createContext();

const initialState = {
  userDetails: {
    name: '',
    about: '',
    phoneNumber: '',
    uid: '',
    profilePhotoUrl: ''
  }
}

const createProfile = (uid, phoneNumber, name, about, profilePhotoUrl) => {
  db.collection("users").doc(uid).set({
    uid,
    phoneNumber,
    name,
    about,
    profilePhotoUrl
  })
}

const reducer = (state, action) =>{
  switch(action.type){
    case 'LOG_IN':
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          ...action.details
        }
      };
    case 'SET_USER':
      createProfile(action.details.uid, action.details.phoneNumber, action.details.name, action.details.about, action.details.profilePhotoUrl)
      return {
        ...state,
        userDetails: {
          ...action.details
        }
      };
    case 'LOG_OUT':
      localStorage.removeItem('loggedInUserInfo');
      return {
        ...state,
        userDetails: {
          name: '',
          phoneNumber: '',
          about: '',
          uid: ''
        }
      };
    default:
      return state
  }
}

export const useStore = () => useContext(whatsappContext);

const StateProvider = ({children}) => {
  return (
    <whatsappContext.Provider value={useReducer(reducer, initialState)}>
      {children}
    </whatsappContext.Provider>)
}

export default StateProvider